<div class="container">
  <h2 mat-dialog-title class="tfa-header w-full">Two-Factor Authentication</h2>
  <mat-dialog-content class="tfa-detail w-full flex">
    <form (ngSubmit)="confirm()">
      <div class="totp-container w-full">
        <div class="form-group">
          <label for="totp" class="form-label"
            >Enter Authenticator App Code:</label
          >
          <input
            type="text"
            id="totp"
            inputmode="tel"
            class="form-input"
            placeholder="Code"
            name="totp"
            [(ngModel)]="totp"
            autocomplete="off"
          />
        </div>
      </div>
      <mat-dialog-actions class="tfa-actions flex w-full">
        <button
          type="submit"
          [disabled]="!totp"
          mat-button
          class="primary-button flex w-full"
        >
          <span>Confirm</span>
        </button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>
